import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "d-flex flex-column d-lg-flex flex-lg-column flex-xl-row justify-content-lg-between px-lg-0 align-items-lg-center position-relative" }
const _hoisted_2 = { class: "col-12 col-xl-6 px-0 d-flex flex-column nowrap align-items-start" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column flex-lg-row nowrap text-grey-900"
}
const _hoisted_4 = {
  key: 0,
  class: "me-4 text-nowrap caption"
}
const _hoisted_5 = { class: "caption-strong text-grey-900 mt-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "me-1" }
const _hoisted_11 = { class: "d-flex flex-column flex-lg-row align-items-start" }
const _hoisted_12 = { class: "col-12 col-xl-6 px-0 d-flex flex-lg-row nowrap justify-content-end align-items-end" }
const _hoisted_13 = { class: "d-flex flex-column d-lg-flex flex-lg-row justify-content-center align-items-center w-100 px-0 px-lg-2" }
const _hoisted_14 = { class: "col-12 col-lg-7 px-0 pe-lg-1 d-lg-flex justify-content-end" }
const _hoisted_15 = {
  key: 0,
  class: "d-none d-lg-inline-block ps-lg-1 position-relative"
}
const _hoisted_16 = { class: "col-12 col-sm-6 col-lg-5 px-0 d-flex align-items-center justify-content-center accommodation-btn ms-lg-3" }

import {
	computed,
	ComputedRef,
	watch,
} from "vue"
import { useStore } from "vuex"

// Store
import packageDetailsContentMap from "@/config/packageDetailsContentMap"

// Config
import trainPackCode from "@/config/trainPackCode"

// Computed
import getWiypData from "@/vue/planning/computed/getWiypData"

//import store from "@/vue/planning/store/store"
import Prices from "@/vue/planning/components/common/prices.vue"
import PricesPP from "@/vue/planning/components/common/pricesPP.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue"
import responsesCache from "@/vue/planning/state/responsesCache"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue"
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";

// import FixFlexTag from "@/vue/planning/components/result/prestation/FixFlexTag.vue";

// Logic
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getMaxPromo,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount"

import displayPrice from "@/displayPrice/displayPrice"

import { getCancellationLastDate } from "@/vue/planning/logic/zeroCode"
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

interface Props {
	variant: any
}
interface Emits {
	(e: "select", id: string): void
	(e: "clear", id: string): void
	(e: "dropdownSelect", selectedData: { newSelected: number; id: string }): void
	(e: "dropdownClick", obj: any): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PrestVariantPierreVacance',
  props: {
    variant: { default: {} }
  },
  emits: ["select", "clear", "dropdownSelect", "dropdownClick"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props
const emit = __emit

const checkIfUkWebsite = computed(() => {
	return getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com";
});

// Tracks the specific wiypCall data for this variant.
// Reactivity is provided by getWiypData (origin / participants / packCode) and props.variant.
const wiypCallData = computed(() => getWiypData.value(props?.variant?.prestId));

// computed
const accommodationOnly: ComputedRef<string | undefined> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const accommodation = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(accommodation && accommodation.accomPriceWiyp) {
			return String(accommodation.accomPriceWiyp);
		}
	}
	if (store.state.packCode != 'HS' && store.state.selectedPrestIds && Object.keys(store.state.selectedPrestIds).length > 0) {
		try {
			const price = store.state.prestMaps.prices[store.state.packCode][props.variant.id].priceAccommodationOnly;
			if (price) {
				return displayPrice(parseInt(price) * 100, store.getters.locale) ?? undefined;
			}
		}
		catch (e) {
			console.error(e);
		}
	}
	return undefined;
});

const selectedQuantity: ComputedRef<number> = computed(() => {
	return store.state.selectedPrestIds[props.variant.id]
})

const isFlex: ComputedRef<boolean> = computed(() => {
	return props.variant.pvFlex === "flex"
})

const crossedPrice: ComputedRef<number> = computed(() => {
	if (!props.variant) return NaN;
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const crossed = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(crossed && crossed.publicPriceWiyp) {
			return crossed.publicPriceWiyp;
		}
	}
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
})

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
})

const totalPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const total = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(total && total.sellingPriceWiyp) {
			return total.sellingPriceWiyp;
		}
	}
	return props.variant && getPrestTotalPrice(props.variant);
})

const isDisabledPrest: ComputedRef<boolean> = computed(() => {
	return totalPrice.value <= 0;
});

const maxPromo: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const promoPrice = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(promoPrice && promoPrice.publicPriceWiyp && promoPrice.sellingPriceWiyp) {
			return getMaxPromo(Math.round(( promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) / promoPrice.publicPriceWiyp * 100));
		}
	}
	return props.variant && getPrestMaxPromo(props.variant);
})
const cancellationLastDate: ComputedRef<string> = computed(() => {
	return getCancellationLastDate(props.variant, store.getters.locale)
})

const prestID: ComputedRef<string> = computed(() => {
	const isPvFlex = props.variant.pvFlex ? true : false
	const prestIDToDisplay = isPvFlex ? props.variant.prestIdSource : ""
	return prestIDToDisplay
})

const specialStay: ComputedRef<boolean> = computed(() => {
	// Show special stay UI for any variant with skipass
	return props.variant && props.variant.skipass;
});

const hasMultipleVariantsWithDifferentSkipass: ComputedRef<boolean> = computed(() => {
	// Get all variants from the store or parent component
	const allVariants = store.state.prestationsFromCatalog?.flatMap((p: any) => p.variants || []) || [];
	const skipassValues = new Set(allVariants.map((v: any) => v.skipass).filter(Boolean));
	return skipassValues.size > 1;
});

const packageContent = computed(() => {
	const defaultContent = store.getters.packageInfoContent || [];
	if (store.getters.locale === 'en_US' && props.variant.codePackage && trainPackCode.includes(props.variant.codePackage)) {
		const contentVariables = packageDetailsContentMap.get(props.variant.codePackage);
		if (!contentVariables) {
			console.error(`no content variables for ${props.variant.codePackage}`);
			return defaultContent;
		}
		return contentVariables.map(content => store.state.content[content]) || defaultContent;
	}
	return defaultContent;
});

// Watch wiypCall changes to ensure computed properties recompute
// Watching both the store state and the computed property ensures reactivity
watch(
	[
		() => store.state.wiypCall,
		() => store.state.participants,
		() => store.state.flightOrigin,
		() => store.state.packCode,
		() => store.state.dates,
		() => props.variant,
	],
	() => {
		// Force recomputation by accessing the computed property
		wiypCallData.value;
	},
	{ deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (specialStay.value && !hasMultipleVariantsWithDifferentSkipass.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(store).state.packCode !== 'HS')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(store).state.content.planner_shortStay_rate) + " ", 1),
                    (_unref(store).getters.locale === 'en_US' && props.variant.codePackage && _unref(trainPackCode).includes(props.variant.codePackage))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          (Number(props.variant.skipass) + 1 > 7)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[4] || (_cache[4] = _createTextVNode(_toDisplayString(7))),
                                (Number(props.variant.skipass) + 1 - 7 > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+" + _toDisplayString(Number(props.variant.skipass) + 1 - 7), 1))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_unref(store).state.content.planner_nights), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(Number(props.variant.skipass) + 1) + " " + _toDisplayString(_unref(store).state.content.planner_nights), 1)
                              ], 64))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          (props.variant.skipass)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.variant.skipass), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(store).state.content.days), 1)
                        ]))
                  ]),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(store).state.content.planner_prestationsInclude), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("svg", { class: "icon info-icon tf-icon-10 tf-icon-sm-20" }, [
                    _createElementVNode("use", { "xlink:href": "#___icon___info" })
                  ], -1)),
                  _cache[6] || (_cache[6] = _createTextVNode(" : ")),
                  (packageContent.value && packageContent.value[0])
                    ? (_openBlock(), _createBlock(PackageDetalisPopUp, { key: 0 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageContent.value, (content, content_i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `${content[0]}-${content_i}}`
                            }, _toDisplayString(content), 1))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Inclus, {
                isDisplayPlaceholders: false,
                variant: _ctx.variant,
                class: "mb-3 mb-lg-0 me-lg-4"
              }, null, 8, ["variant"]),
              (specialStay.value && props.variant?.paymentCondition !== undefined)
                ? (_openBlock(), _createBlock(PaymentCondition, {
                    key: 0,
                    paymentCondition: props.variant.paymentCondition,
                    "cancellation-date": _ctx.variant.cancelationUntil,
                    displayTitle: true,
                    isPVFlex: isFlex.value,
                    prestId: prestID.value,
                    class: "d-flex align-items-center w-100 h-100"
                  }, null, 8, ["paymentCondition", "cancellation-date", "isPVFlex", "prestId"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (!specialStay.value && props.variant?.paymentCondition !== undefined)
        ? (_openBlock(), _createBlock(PaymentCondition, {
            key: 1,
            paymentCondition: props.variant.paymentCondition,
            "cancellation-date": _ctx.variant.cancelationUntil,
            displayTitle: true,
            isPVFlex: isFlex.value,
            prestId: prestID.value
          }, null, 8, ["paymentCondition", "cancellation-date", "isPVFlex", "prestId"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(checkIfUkWebsite.value ? PricesPP : Prices), {
            isLoading: _unref(pricesLoadingSet).has(_unref(currentCacheKey)),
            packCode: _ctx.variant && _ctx.variant.codePackage,
            crossedPrice: crossedPrice.value,
            totalPrice: totalPrice.value,
            perPrice: perPrice.value,
            maxPromo: maxPromo.value,
            locale: _unref(store).getters.locale,
            totalParticipants: _unref(store).state.participants.length
          }, null, 8, ["isLoading", "packCode", "crossedPrice", "totalPrice", "perPrice", "maxPromo", "locale", "totalParticipants"])),
          (!checkIfUkWebsite.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _cache[7] || (_cache[7] = _createElementVNode("svg", { class: "info-icon icon tf-icon-10 tf-icon-sm-20" }, [
                  _createElementVNode("use", { "xlink:href": "#___icon___info" })
                ], -1)),
                _createVNode(PackageDetalisPopUp, {
                  top: '0',
                  left: '10px'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(store).state.content.planner_prestationsPriceInfo), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(SelectButton, {
            accommodationOnly: accommodationOnly.value,
            variant: _ctx.variant,
            locale: _unref(store).getters.locale,
            selectedQuantity: selectedQuantity.value,
            select_location: 'prestation',
            disabled: isDisabledPrest.value,
            onSelectClick: _cache[0] || (_cache[0] = (id) => emit('select', id)),
            onDropdownClick: _cache[1] || (_cache[1] = (obj) => emit('dropdownClick', obj)),
            onClear: _cache[2] || (_cache[2] = (id) => emit('clear', id)),
            onDropdownSelect: _cache[3] || (_cache[3] = (payload) => emit('dropdownSelect', payload))
          }, null, 8, ["accommodationOnly", "variant", "locale", "selectedQuantity", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})